import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=4f1f30bb&scoped=true"
import script from "./dashboards.vue?vue&type=script&lang=ts"
export * from "./dashboards.vue?vue&type=script&lang=ts"
import style0 from "./dashboards.vue?vue&type=style&index=0&id=4f1f30bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f30bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1f30bb')) {
      api.createRecord('4f1f30bb', component.options)
    } else {
      api.reload('4f1f30bb', component.options)
    }
    module.hot.accept("./dashboards.vue?vue&type=template&id=4f1f30bb&scoped=true", function () {
      api.rerender('4f1f30bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboards/dashboards.vue"
export default component.exports